import React from 'react';

export function WatchLaterIcon({ ...props }: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="currentColor"
      viewBox="0 0 48 48"
      {...props}
    >
      <path d="M24 4C13 4 4 13 4 24s9 20 20 20 20-9 20-20S35 4 24 4zm0 36c-8.82 0-16-7.18-16-16S15.18 8 24 8s16 7.18 16 16-7.18 16-16 16zm1-25a1 1 0 00-1-1h-1a1 1 0 00-1 1v10.441a1 1 0 00.476.852l9.072 5.583a1 1 0 001.376-.328l.546-.887a1 1 0 00-.337-1.381L25 24.4V15z" />
    </svg>
  );
}
